module.exports = __webpack_public_path__ + "static/media/22-004.42bf5fbc.png";